<div class="input-group">
    <div class="input-group-prepend" (click)="toggleKeyboard()">
        <span class="input-group-text">
            <mat-icon svgIcon="keyboard"></mat-icon>
        </span>
    </div>
    <input appScannerDetect #searchInputBasketField [disableKeyPress]="disableKeyPress || !disableKeyboard"
        [disabled]="disableKeyboard" type="text" [(ngModel)]="searchText" class="form-control scanner-input"
        placeholder="{{ placeholder }}" (onDetected)="onDetected($event)" (onDelete)="onDelete()" *ngIf="showSearch"
        [attr.inputmode]="getInputMode"/>

    <div *ngIf="searchText != ''" class="input-group-append" (click)="clearSearchInput()">
        <span class="input-group-text">
            <mat-icon svgIcon="delete-outline"></mat-icon>
        </span>
    </div>
    <div *ngIf="disableKeyPress && searchText == ''" class="input-group-append" (click)="enableBasketScanning()">
        <span class="input-group-text">
            <mat-icon svgIcon="search"></mat-icon>
        </span>
    </div>
    <div *ngIf="!disableKeyPress && searchText == ''" class="input-group-append" (click)="disableBasketScanning()">
        <span class="input-group-text">
            <mat-icon svgIcon="cancel"></mat-icon>
        </span>
    </div>
</div>